import script from "./MonthlyContentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyContentDetail.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyContentDetail.vue?vue&type=style&index=0&id=2e3aac30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e3aac30"]])

export default __exports__